import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { MbscModule } from '@mobiscroll/angular';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// import { HeaderComponent } from '@larsthoennestridimo/shared-ui';
import { freeSet } from '@coreui/icons';
import { ThemeService } from './services/shared/theme/theme.service';
import { AuthService } from './services/auth/service/auth.service';
import { GetUserService } from './services/fetchUser/GET/get-user.service';
import { HeaderComponent } from "./components/shared/components/header/header.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, FormsModule, MbscModule, CommonModule, HeaderComponent, HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  userName = '';
  userEmail = '';
  userIconUrl = '/assets/icons/user.png';
  icons = freeSet;

  constructor(
    private router: Router,
    public themeService: ThemeService,
    private authService: AuthService,
    private getUserService: GetUserService
  ) {}

  ngOnInit(): void {
    this.loadUserData();
  }

  loadUserData() {
    const firstname = localStorage.getItem('firstName');
    const lastname = localStorage.getItem('lastName');
    this.userName = `${firstname ?? ''} ${lastname ?? ''}`;

    const userJson = localStorage.getItem('authUser');
    if (userJson) {
      const data = JSON.parse(userJson);
      this.userEmail = data.user.email ?? '';
    }

    // optionales Profilbild laden
    this.getUserService.loadUserIcon().subscribe(blob => {
      if (blob && blob.size > 0) {
        this.userIconUrl = URL.createObjectURL(blob);
      }
    });
  }

  isLoginRoute(): boolean {
    return this.router.url === '/login';
  }

  onLogout() {
    this.authService.logout();
  }

  openWebsite(path: string) {
    if (path === 'intranet') window.open('https://intranet.tridimo.de/dashboard', '_blank');
    else if (path === 'aufgaben') window.open('https://aufgaben.tridimo.de/todo', '_blank');
    else if (path === 'bestaetigung') window.open('https://bestaetigung.tridimo.de', '_blank');
    else if (path === 'reload') window.location.reload();
  }
}
